import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }

    render() {
        return (
            <ParadigmaModal
                fileUploader={true}
                getUrl={api.proyectos.config.firmas.edit}
                postUrl={api.proyectos.config.firmas.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"La Firma ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Editar Firma"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.SetData(data)}
            >
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className={'mt-2'}>
                    <Col className="col-2">
                        <Label>Cargo</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="cargo"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                
                <Row className={'mt-2'}>
                    <Col className="col-2">
                        <Label>Imagen</Label>
                    </Col>
                    <Col className="col-10">    
                        <Input type="file" name="imagen" accept="image/*"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>

                <Row className={'mt-2'}>
                    <Col className="col-12">
                        <img src={api.BASE_URL + this.state.fileurl} alt="" width="100%"></img>
                    </Col>
                </Row>
                
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Firmas/Edit.js